import { useEffect, useState } from 'react'
import CustomModal from '../CustomModal'
import CustomButton from '../CustomButton'
import { homeScreenRedirection } from '../../../utils/helper'
import { getCurrentSubsidiaryId, redirectWithSubsidiary } from '../../../utils/subsidiary'
import { onPermissionDenied } from '../../../utils/permissionDenied'

type Props = {
  // Pass explicitly (`open` or `open={true}`) for controlled usage, shown immediately
  // while mounted (e.g. SubsidiaryBoundary's URL-subsidiary-mismatch case). Omit for
  // self-managed usage: mounted once at the app root, stays hidden until the axios
  // interceptor signals a permission-denied 401 via onPermissionDenied.
  open?: boolean
}

const PermissionDeniedModal = ({ open: controlledOpen }: Props) => {
  const [signalledOpen, setSignalledOpen] = useState(false)

  useEffect(() => {
    if (controlledOpen !== undefined) return
    return onPermissionDenied(() => setSignalledOpen(true))
  }, [controlledOpen])

  const open = controlledOpen ?? signalledOpen

  const redirectHome = () => {
    redirectWithSubsidiary(getCurrentSubsidiaryId(), homeScreenRedirection())
  }

  return (
    <CustomModal open={open} setOpen={redirectHome} title="Permission Required" titleClasses="w-full text-center" hideClose hideDivider contentClasses="!pb-6 w-[480px]">
      <div className="flex flex-col justify-center align-center py-4">
        <p className="text-sm text-center text-gray-500">You currently do not have the permission to access this.</p>
        <p className="text-sm text-center text-gray-500"> Please contact your Admin.</p>
      </div>
      <CustomButton onClick={redirectHome} className="!w-full !rounded-xl">
        Okay
      </CustomButton>
    </CustomModal>
  )
}

export default PermissionDeniedModal
